export default {
  LEGAL_CASES: "clientReference,cdReference,client,caseTitle",
  CLIENTS: "name,town,contactEmail,telephoneNumber",
  FEE_EARNERS: "firstName,lastName,emailAddress,telephoneNumber",
  COURTS: "name,town,telephoneNumber"
}